import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { ButtonWithPopover } from '@/core/ButtonWithPopover.molecule';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import type { PopoverConfig } from '@/core/ButtonWithPopover.molecule';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

type ButtonWithPopoverValue = string | number | [string, number] | undefined;
type PopoverLabelRender = (args: { className?: string }) => React.ReactNode;
type PopoverContentRender = (args: {
  onChange: (value: string | number | [string, number]) => void;
  value: ButtonWithPopoverValue;
}) => React.ReactNode;

export interface ButtonWithPopoverIF extends ValidatingFormComponent<ButtonWithPopoverValue> {
  component: 'ButtonWithPopoverFormComponent';
  popoverLabel: PopoverLabelRender;
  popoverContent: PopoverContentRender;
  popoverConfig: PopoverConfig;
  closeOnClick?: boolean;
  labelClasses?: string;
}

export const ButtonWithPopoverFormComponent = (props: ButtonWithPopoverIF) => {
  const {
    name,
    testId = 'buttonWithPopover',
    label,
    labelClasses,
    popoverLabel,
    popoverConfig,
    popoverContent,
    closeOnClick,
    extendValidation,
    validation,
    customErrorText,
  } = props;

  const formState = useForm().getState();
  const showError = _.has(formState.errors, name) && _.has(formState.dirtyFields, name);

  const defaultValidation = (value: ButtonWithPopoverValue) => _.isUndefined(value);
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  return (
    <FormFieldWrapper testId={testId} label={label} showError={showError} customErrorText={customErrorText}>
      <Field<ButtonWithPopoverValue> name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const { onChange, value, className } = getFormFieldProps(formState, input, meta, props);

          return (
            <ButtonWithPopover
              shouldTriggerFullWidth
              hasArrow
              extraClassNames={labelClasses}
              label={popoverLabel({ className })}
              popoverConfig={popoverConfig}
              isCloseOnContentClick={closeOnClick}>
              {popoverContent({ onChange, value })}
            </ButtonWithPopover>
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};
